import { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import axios from 'axios'
import throttle from 'lodash/throttle'
import { defaultInstance } from 'tennders-stracture/libs/api'

const useRoutesSearch = (keyword, setSuggestion, setIsSmart, searchGoogle, value) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const source = useRef(null)

  const fetchData = useCallback(async () => {
    if (keyword?.length < 2) {
      setSuggestion([])
      return
    }

    if (keyword === value?.label) {
      return
    }
    try {
      if (source.current) {
        source.current.cancel()
      }

      setLoading(true)
      source.current = axios.CancelToken.source()
      const { data } = await defaultInstance.get(`/utils/routes?keyword=${keyword}`, { cancelToken: source.current.token })
      setSuggestion(data)

      if (data.length === 0) {
        searchGoogle(keyword)
        setIsSmart(false)
      } else {
        setIsSmart(true)
      }
      setLoading(false)
    } catch (err) {
      if (axios.isCancel(err)) {
        // handle error
      } else {
        setError(err)
        setLoading(false)
      }
    }
  }, [keyword])

  const throttledFetch = useMemo(() => throttle(fetchData, 500), [fetchData])

  useEffect(() => {
    throttledFetch()
  }, [throttledFetch])

  return [loading, error]
}

export default useRoutesSearch
